/* eslint max-len: "off" */
const Base64 = require('./shared/base64_utf8');
const { Tracker } = require('@reverbdotcom/discovery-ui');
const elog = require('@reverbdotcom/elog').default;

const JS_ERROR = 'js_error';
const JS_WARNING = 'js_warning';
const ELOG_CONFIG_KEY = 'elog-config';
const CURRENT_USER_KEY = 'current-user';

const ERROR_IGNORE_LIST = [
  'TypeError: null is not an object (evaluating \'elt.parentNode\')',
  // https://bugs.chromium.org/p/chromium/issues/detail?id=590375
  'SecurityError (DOM Exception 18): Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://staticxx.facebook.com". The frame being accessed set "document.domain" to "facebook.com", but the frame requesting access did not. Both must set "document.domain" to the same value to allow access.',
  'SecurityError (DOM Exception 18): Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://dis.us.criteo.com". Protocols, domains, and ports must match.',
  'SecurityError (DOM Exception 18): Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://bid.g.doubleclick.net". Protocols, domains, and ports must match.',
  'SecurityError (DOM Exception 18): Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://gum.criteo.com". Protocols, domains, and ports must match.',
  'TypeError: undefined is not an object (evaluating \'__gCrWeb.autofill.extractForms\')',
  'SecurityError (DOM Exception 18): Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://www.youtube.com". Protocols, domains, and ports must match.',
  'TypeError: undefined is not an object (evaluating \'document.getElementsByClassName("docs-homescreen-gb-container")[0].style\')',
];

const USER_AGENT_IGNORE_LIST = [
  /* Error: Blocked a frame with origin "https://reverb.com" from accessing a cross-origin frame.
    at Object.hash_wo (https://cot.attacksspaghetti.com/affs?addonname=[Enter%20Product%20Name]&clientuid=[Enter%20Client%20UID]&subID=mas&affid=9670&subaffid=1001&href=https%3A%2F%2Freverb.com%2Fitem%2F4524482-schecter-diamond-series-xxx-2006-gloss-black:12:1869)
    at https://cot.attacksspaghetti.com/affs?addonname=[Enter%20Product%20Name]&clientuid=[Enter%20Client%20UID]&subID=mas&affid=9670&subaffid=1001&href=https%3A%2F%2Freverb.com%2Fitem%2F4524482-schecter-diamond-series-xxx-2006-gloss-black:12:10057
    at Function.<anonymous> (https://cot.attacksspaghetti.com/affs?addonname=[Enter%20Product%20Name]&clientuid=[Enter%20Client%20UID]&subID=mas&affid=9670&subaffid=1001&href=https%3A%2F%2Freverb.com%2Fitem%2F4524482-schecter-diamond-series-xxx-2006-gloss-black:12:5893)
    at nrWrapper (https://reverb.com/item/4524482-schecter-diamond-series-xxx-2006-gloss-black:26:11526)
  */
  'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/57.0.2987.133 Safari/537.36',
];

function parseMeta(tagName) {
  let content;

  try {
    content = document
      .querySelector(`meta[name=${tagName}]`)
      .getAttribute('content');

    return JSON.parse(Base64.decodeToString(content));
  } catch (e) {
    return null;
  }
}

function isBot() {
  const userConfig = parseMeta(CURRENT_USER_KEY);

  return userConfig &&
    userConfig.user &&
    userConfig.user.isBot;
}

function initializeElog() {
  const elogConfig = parseMeta(ELOG_CONFIG_KEY);

  if (elogConfig) {
    elog.configure(elogConfig.elog);
    elog.identify(elogConfig.elog.userContext);
    Tracker.pageView();
  }
}

function logError(message, url, line, column, error) {
  const userAgent = navigator.userAgent;

  const data = {
    message,
    url,
    line,
    column,
    stacktrace: error,
    userAgent,
  };

  if (ERROR_IGNORE_LIST.indexOf(message) >= 0) {
    return false;
  }

  if (USER_AGENT_IGNORE_LIST.indexOf(userAgent) >= 0) {
    return false;
  }

  if (isBot()) { return false; }

  elog.error(JS_ERROR, data, message);
  return false;
}

function logWarning(message) {
  const data = {
    message,
    url: window.location.href,
    userAgent: navigator.userAgent,
    stacktrace: (new Error()).stack,
  };

  if (isBot()) { return false; }

  elog.info(JS_WARNING, data);
  return false;
}

function logJqueryMigrateWarnings() {
  // monkeypatch jQuery.migrateWarnings.push to also elog a warning
  if (jQuery && jQuery.migrateWarnings) {
    const originalPush = jQuery.migrateWarnings.push;
    jQuery.migrateWarnings.push = (warning) => {
      logWarning(warning);
      originalPush.call(jQuery.migrateWarnings, warning);
    };
  }
}

const PERFORMANCE_SAMPLE = 0.1;

function trackPerformanceStats() {
  const timing = window.performance && window.performance.timing;

  if (Math.random() > PERFORMANCE_SAMPLE || !timing) {
    return;
  }

  const start = timing.navigationStart;

  const stats = {
    url: window.location.href,
    redirectStart: timing.redirectStart && (timing.redirectStart - start),
    redirectTime: timing.redirectEnd - timing.redirectStart,
    fetchStart: timing.fetchStart - start,
    domainLookupStart: timing.domainLookupStart - start,
    domainLookupTime: timing.domainLookupEnd - timing.domainLookupStart,
    connectStart: timing.connectStart - start,
    connectTime: timing.connectEnd - timing.connectStart,
    requestStart: timing.requestStart - start,
    responseStart: timing.responseStart - start,
    responseTime: timing.responseEnd - timing.responseStart,
    requestResponseTime: timing.responseEnd - timing.requestStart,
    domLoadingStart: timing.domLoading - start,
    domInteractiveStart: timing.domInteractive - start,
    domContentLoadedEventStart: timing.domContentLoadedEventStart - start,
    domContentLoadedEventTime: timing.domContentLoadedEventEnd - timing.domContentLoadedEventStart,
    loadEventStart: timing.loadEventStart - start,
    responseToLoadTime: timing.loadEventStart - timing.responseEnd,
  };

  elog.track('browser.timings', stats);
}

function init() {
  initializeElog();
  window.onerror = logError;
  logJqueryMigrateWarnings();

  window.addEventListener('load', trackPerformanceStats);
}

module.exports = {
  init,
  logError,
  trackPerformanceStats,  // for testing only
};



// WEBPACK FOOTER //
// ./javascripts/components/error_logger.js